// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from 'src/App';
import routes from 'src/router/index.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../icons';
import VueRouter from 'vue-router';
import VueCookie from 'vue-cookie';
import VueAmap from 'vue-amap';
import filter from 'src/common/js/filter.js';
import echarts from 'echarts';
// var echarts = require('echarts');
import Vuex from 'vuex';
import store from 'src/store/store.js';
import indexCss from 'static/css/index.css';
import common from 'src/common/js/index.js';
import directive from 'src/directive';
// import dataV from '@jiaminghi/data-view';

// 引入全局css
// import 'src/components/big-screen/assets/scss/style.scss';
// 按需引入vue-awesome图标
// import Icon from 'vue-awesome/components/Icon';
// import 'vue-awesome/icons/chart-bar.js';
// import 'vue-awesome/icons/chart-area.js';
// import 'vue-awesome/icons/chart-pie.js';
// import 'vue-awesome/icons/chart-line.js';
// import 'vue-awesome/icons/align-left.js';

Vue.config.productionTip = false;

Vue.use(VueCookie);
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(VueAmap);
Vue.use(Vuex);
Vue.use(directive);
// Vue.use(dataV);
// 全局注册
// Vue.component('icon', Icon);

VueAmap.initAMapApiLoader({
    key: '1e5d41462bf2cb77258167eee0e6a73b',
    plugin: [
        'AMap.Autocomplete',
        'AMap.PlaceSearch',
        'AMap.Scale',
        'AMap.OverView',
        'AMap.ToolBar',
        'AMap.MapType',
        'AMap.PolyEditor',
        'AMap.CircleEditor',
        'AMap.Geocoder',
        'AMap.DistrictSearch',
        'AMap.Geolocation',
        'AMap.Marker'
    ],
    // 默认高德 sdk 版本为 1.4.4
    uiVersion: '1.0.11', // 版本号
    v: '1.4.15'
});

// 添加全局方法
Vue.prototype.$vueAmap = VueAmap;
Vue.prototype.$echarts = echarts;
Vue.prototype.common = common;
Vue.prototype.$bus = new Vue();

const router = new VueRouter({
    routes: routes.getInitRoute()
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js